import { API_APP_ID, API_PATHS, buildApiUrl } from "../../config";
import { createApiClient } from "./createApiClient";

/**
 * Unauthenticated CRM public apps API.
 * Base: {API_BASE_URL}api/v1/public/apps/
 * Requires X-App-Id on every request.
 */
const publicAppsClient = createApiClient({
  baseURL: buildApiUrl(API_PATHS.PUBLIC_APPS),
  headers: {
    "X-App-Id": API_APP_ID,
  },
});

export default publicAppsClient;
